var Queensland = "昆士蘭省";
var Tasmania = "塔斯馬尼亞";
var Victoria = "維多利亞省";
var AUStates = {
	"Australian Capital Territory": "澳大利亞首都特區",
	"New South Wales": "新南威爾斯",
	"Northern Territory": "北部領地",
	Queensland: Queensland,
	"South Australia": "南澳大利亞",
	Tasmania: Tasmania,
	Victoria: Victoria,
	"Western Australia": "西澳大利亞"
};

export { Queensland, Tasmania, Victoria, AUStates as default };
